import React from "react"
import routes from "routes"
import { SearchType } from "src/components/hooks/useCreatorSearch"
import Link from "next/link"

type Props = {
  onSubmit: (e: React.FormEvent) => void
  searchType: SearchType
  setSearchType: (type: SearchType) => void
  updateSearchText: (text: string) => void
  searchText?: string
  type?: string
}

const SearchForm: React.FC<Props> = ({
  onSubmit,
  searchType,
  setSearchType,
  updateSearchText,
  searchText,
  type = "type01",
}) => {
  const onChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setSearchType(e.target.value as typeof searchType)
  }

  return (
    <form onSubmit={onSubmit} className={`p-creatorSearch -${type}`}>
      <div className="p-creatorSearch-category">
        <h3>カテゴリー</h3>
        <div className="p-creatorSearch-category-radio">
          <label className="c-radio-secondary">
            <input
              className="c-radio-secondary-input"
              type="radio"
              name="illustrations"
              value="illustrations"
              checked={searchType === "illustrations"}
              onChange={(e) => onChange(e)}
            />
            <span className="c-radio-secondary-text">イラスト</span>
          </label>
          <label className="c-radio-secondary">
            <input
              className="c-radio-secondary-input"
              type="radio"
              name="novels"
              value="novels"
              checked={searchType === "novels"}
              onChange={(e) => onChange(e)}
            />
            <span className="c-radio-secondary-text">小説</span>
          </label>
        </div>
      </div>
      <div className="p-creatorSearch-freeword">
        <h3>作者名・作品名・ジャンルなど</h3>
        <div className="p-creatorSearch-freeword-textfield">
          <input
            className="c-textfield-primary"
            type="text"
            placeholder="フリーワード検索"
            value={searchText}
            onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
              updateSearchText(e.target.value)
            }}
          />
        </div>

        <ul className="p-creatorSearch-otherSearch">
          <li className="p-creatorSearch-otherSearch-item">
            <a
              className="p-creatorSearch-otherSearch-anchor"
              href={routes.creatorSearchGenres(searchType)}
            >
              ジャンルで検索
            </a>
          </li>
          {searchType !== "illustrations" && (
            <li className="p-creatorSearch-otherSearch-item">
              <Link href={routes.creatorSearchCharacters()}>
                <a className="p-creatorSearch-otherSearch-anchor">
                  キャラクターで検索
                </a>
              </Link>
            </li>
          )}
        </ul>
      </div>
      <div className="p-creatorSearch-submit">
        <button className="p-creatorSearch-submit-button c-button-secondary">
          検索する
        </button>
      </div>
    </form>
  )
}

export default SearchForm
